/**
 * transforms app context request
 * @param {Object} response
 * @return {Object}
 */
export const transformAppContext = (response) => {
  return response;
};
